<script setup lang="ts">
defineProps<{
  /** スライド数の最大値 */
  max: number,
  /** 現在のスライド */
  current: number
}>();
</script>

<template>
  <div class="body">
    <div
      v-for="slideNumber in max"
      :key="slideNumber"
      class="number"
      :class="{ active: slideNumber === current }"
    >
      {{ slideNumber }}
    </div>
  </div>
</template>

<style lang="scss">

</style>